import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { selectUniqueCodeNames } from '@tv3/store/custom-codes/custom-code.selectors'
import { GetAllCustomCodes } from '@tv3/store/custom-codes/custom-code.actions'
import { DataDictService } from '@tv3/services/data-dict.service'
import * as R from 'ramda'
import { DataCheckerService, Destroyable } from '@tokeet-frontend/tv3-platform'
import {
  attrDescriptionToDataToken,
  AttributeDescriptionGuard,
  selectAllAttributeDescriptions,
} from '@tokeet-frontend/custom-attrs'
import { CustomCodeGuard } from '@tv3/guards/custom-code.guard'
import { map } from 'rxjs/operators'
import * as lodash from 'lodash'

@Component({
  selector: 'app-data-dictionary-dialog',
  host: { class: 'modal-content' },
  templateUrl: './data-dictionary-dialog.component.html',
  styleUrls: ['./data-dictionary-dialog.component.scss'],
})
export class DataDictionaryDialogComponent extends Destroyable implements OnInit {
  dictionary = {
    ...this.dataDictService.getAvailableKeys(),
  }

  invoiceTags = [
    { key: `*|BRANDING:name|*`, tooltip: $localize`The name of the user who is sending the message.` },
    { key: `*|BRANDING:reference_id|*`, tooltip: $localize`A unique AdvanceCM id for this specific message.` },
    { key: `*|BRANDING:invoice_link|*`, tooltip: $localize`The URL to your invoice.` },
  ]

  hasBranding = false

  custom$ = this.store.pipe(select(selectUniqueCodeNames))
  attrs$ = this.store.pipe(
    select(selectAllAttributeDescriptions),
    map((items) => {
      return lodash.flatten(lodash.map(items, (item) => attrDescriptionToDataToken(item)).filter((t) => !!t.length))
    })
  )

  constructor(
    public dialogRef: MatDialogRef<DataDictionaryDialogComponent>,
    private store: Store<fromRoot.State>,
    private dataChecker: DataCheckerService,
    @Inject(MAT_DIALOG_DATA) public data: { branding: boolean },
    private dataDictService: DataDictService
  ) {
    super()
    this.dataChecker.check([AttributeDescriptionGuard, CustomCodeGuard])
  }

  ngOnInit() {
    this.hasBranding = R.pathOr(false, ['branding'], this.data)
  }

  addTag(tag: string) {
    this.dialogRef.close(tag)
  }

  close() {
    this.dialogRef.close()
  }
}
